import React from "react"

function AlignMiddle({ size }) {
    return (
        <svg viewBox="0 0 24 24" height={size}><path d="M22 11h - 5V6h - 3v5h - 4V3H7v8H1.84v2H7v8h3v - 8h4v5h3v - 5h5z"></path></svg>
    )
}

export default AlignMiddle